// 状态
export const STATUS_CODE = {
  enabled: { label: '生效', value: 'Y' },
  disabled: { label: '失效', value: 'N' }
}

// 是否防跳站
export const IS_JUMP_STATION = {
  yes: { label: '是', value: 'Y' },
  no: { label: '否', value: 'N' }
}

// 工序类型 开工、报工、入库
export const PROCESS_TYPE = {
  start: { label: '开工', value: 'start' },
  report: { label: '报工', value: 'report' },
  in: { label: '入库', value: 'in' }
}
